window.jQuery = require('jquery/dist/jquery');
window.$ = window.jQuery;
require('./bootstrap');
require('bootstrap/dist/js/bootstrap');
require('datatables/media/js/jquery.dataTables');
require('./adminlte');
require('./bootstrap3-typeahead.min');
require('select2/dist/js/select2');
require('bootstrap-datepicker/dist/js/bootstrap-datepicker');
require('icheck/icheck');
require('spectrum-colorpicker/spectrum');
window.moment = require('moment/moment');
window.countdown = require('countdown/countdown');

// Datepicker defaults
$.fn.datepicker.defaults.format = "yyyy-mm-dd";
$.fn.datepicker.defaults.autoclose = true;
$.fn.datepicker.defaults.weekStart = 1;

// init tooltips
$(function () {
    $('[data-toggle="tooltip"]').tooltip({
        container: 'body'
    })
});

// init icheck
$('input[type=checkbox]').iCheck({
    checkboxClass: 'icheckbox_flat-blue',
}).on('ifUnchecked', function(event) {
    $(this).val('off');
}).on('ifChecked', function(event) {
    $(this).val('on');
});

/*
window.Vue = require('vue');

Vue.component('example-component', require('./components/ExampleComponent.vue'));

const app = new Vue({
    el: '.wrapper'
});

*/